// extracted by mini-css-extract-plugin
export default {"bwr":"styles_bwr__Z2qca","removeIcon":"styles_removeIcon__rOJUx"};